module.exports = __webpack_public_path__ + "img/9788994077024.82c9e854.jpg";